const DB_NAME = 'OfflineRecordsDB';
const STORE_NAME = 'records';

export const initDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);

    request.onerror = () => reject("IndexedDB initialization failed");

    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      db.createObjectStore(STORE_NAME, { keyPath: "id", autoIncrement: true });
    };
  });
};

export const addRecord = (db: IDBDatabase, record: any): Promise<number> => {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.add(record);

    request.onerror = () => reject("Error adding record to IndexedDB");
    request.onsuccess = () => resolve(request.result as number);
  });
};

export const getAllRecords = (db: IDBDatabase): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], "readonly");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.getAll();

    request.onerror = () => reject("Error getting records from IndexedDB");
    request.onsuccess = () => resolve(request.result);
  });
};

export const clearAllRecords = (db: IDBDatabase): Promise<void> => {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.clear();

    request.onerror = () => reject("Error clearing records from IndexedDB");
    request.onsuccess = () => resolve();
  });
};

// New function to delete a single record
export const deleteRecord = (db: IDBDatabase, id: number): Promise<void> => {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.delete(id);

    request.onerror = () => reject("Error deleting record from IndexedDB");
    request.onsuccess = () => resolve();
  });
};